import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import ProgressBar from 'components/ProgressBar';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import { useQuery, useMutation } from '@apollo/client';
import { GENERATE_KEY, GET_ALL_AVAILABLE_KIOSKS } from 'graphql/service';
import { Head, Container, StateContainer, Content, Footer } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const PrintKey = ({name, status}) => {

  const history = useHistory()
  const groupId = useParams().groupId

  const [options, setOptions] = useState([
    {label: "Manual Check", value: "Manual Check"},
  ])

  const [method, setMethod] = useState("")
  const [orderOfKeys, setOrderOfKeys] = useState(1)
  const [totalKeys, setTotalKeys] = useState(2)

  useQuery(GET_ALL_AVAILABLE_KIOSKS,
    {
      onCompleted: (availableKiosksData) => {
        if(availableKiosksData.availableKiosks.length > 0) {
          const newOptions = availableKiosksData.availableKiosks?.map((kiosk) => ({label: kiosk.username, value: kiosk.kioskId}))
          newOptions.push({label: "Manual Check", value: "Manual Check"})
          setOptions(newOptions)
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const [generateKey, { loading: generateKeyLoading }] = useMutation(GENERATE_KEY,
    {
      onCompleted: (data) => {
        //FIXME: update this when the backend is ready
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )
    
  const handleSend = () => {
    if(generateKeyLoading) return
    if(method === "") {
      const content = "Please select a method"
      debouncedErrorMessage(content);
    } else {
      generateKey({
        variables: {
          input: {
            groupId: groupId,
            kioskId: method
          }
        }
      })
    }
  }

  return (
    <Container>
      <ProgressBar step={4} groupId={groupId} status={status}/>
      {generateKeyLoading ? (
        <StateContainer>
          <div className="instruction">
            <div className="title">
              <span>Printing key for: </span>
              <span className="highlight">{name}</span>
            </div>
            <div className="text">{`Printing ${orderOfKeys}/${totalKeys}...`}</div>
          </div>
        </StateContainer>
      ):(
        <>
      <Content>
        <Head>Keycard Printing</Head>
        <div className='text'>
          <div>Which keycard printing device would you like to use?</div>
        </div>
        <Dropdown
          mainPage
          options={options}
          value={options.find(option => option.value === method)?.label || "- Select -"}
          title="PREFERRED DEVICE"
          onChange={(e) => {
            setMethod(e)
          }}
        />
      </Content>
      <Footer>
        <div className='buttonContainer'>
          <Button
            mainPage
            success
            onClick={handleSend}
            data-loading={generateKeyLoading}
            additionalstyle={`
              width: 72px;
            `}
          >
            {generateKeyLoading? null: 'Send'}
          </Button>
        </div>
      </Footer>
      </>)}
    </Container>
  );
}

export default PrintKey;